var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"wrapper"},[_c('v-app',{class:[{ dark: _vm.$vuetify.theme.dark }, { light: !_vm.$vuetify.theme.dark }]},[_c('v-main',[[_c('router-view')]],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }